import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';

export const MultiTenantForm = ({
  projectId,
  version,
  multiTenantPlugin,
  installedPlugins,
  installMultiTenantPlugin,
  addMultiTenantFlag,
}) => {
  const [responseFlag, setResponseFlag] = useState(false);
  const history = useHistory();

  const handleSubmit = (values) => {
    setResponseFlag(true);
    const payload = {
      projectId,
      version,
      collectionName: values.collectionName || 'Organisation',
    };
    installMultiTenantPlugin(payload).then((res) => {
      history.push(`/2.0/on-boarding/${version}/v/${projectId}/global-theme`);
      setResponseFlag(false);
    });
  };

  const multiTenantInstalled = installedPlugins.find((plg) => plg.code === 'MULTI_TENANT_SAAS');

  return (
    <div className="on-boarding-default-page">
      <Formik
        enableReinitialize={true}
        initialValues={{
          collectionName: '',
        }}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form className="form-horizontal collection-constructor-form">
            <div className="row" style={{ paddingLeft: '15px' }}>
              <div className="col-md-12 mb-5 mt-4">
                <FormFieldWithLabel
                  cta={false}
                  label="Tenant Collection Name (Optional)"
                  icon="text"
                  infoIcon={true}
                  infoDescription={'Name of tenant collection.'}
                >
                  <Field
                    type="text"
                    name="collectionName"
                    className="form-control form-control-sm"
                    placeholder="Tenant Collection (Default: Organisation)"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="fixed-button-bar mt-4">
              <div className="">
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 text-left">
                    <Link
                      className="btn btn-outline-primary btn-md"
                      to={`/2.0/on-boarding/${version}/v/${projectId}/global-theme`}
                      title="Goto Next Step"
                    >
                      <i className="wb webconnect-skip-forward-fill"></i> Skip to next step
                    </Link>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 text-right">
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-md"
                      title="Add & continue to next step"
                      disabled={!multiTenantPlugin || multiTenantInstalled || responseFlag}
                    >
                      <i className="wb webconnect-save-regular"></i> Add & continue to next step
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
